<div>
  <div class="container-fluid">
    <div class="now-error-container">
      <div class="now-error-content">
        <h1 class="h2">Entschuldigung!</h1>
        <p class="now-body-large">
          Ein unerwarteter Fehler ist aufgetreten. Natürlich stehen wir Ihnen nach wie vor zur
          Verfügung. Bitte nutzen Sie unsere Startseite.
        </p>
        <a
          class="now-btn now-btn-primary now-btn-icon now-icon-arrow-right-after"
          [attr.href]="nowPortalBasePath"
        >
          Zur Startseite
        </a>
      </div>
      <img
        title="Fehler"
        class="img404"
        src="assets/images/u473.svg"
        alt="Ein unerwarteter Fehler ist aufgetreten"
      />
    </div>
  </div>
</div>
